<!--  -->
<template>
  <div class="popup-container">
      <van-popup v-bind="$attrs" v-on="$listeners">
        <div class="popup__title">{{$t('homePage.stayTuned')}}</div>
        <div class="popup__content">
          <div class="popup__content__text">请您在这里提交项目上线申请，我们将安排商务人员跟您联系。</div>
          <div class="popup__content__text">为了加快审核速度，请您确保填写内容的真实性和准确性，项目审核结果我们将仅通过邮件，请不要相信其它渠道的信息。也不要相信任何人的付费上币服务，如果有任何疑问，发邮件到XXX@gmail.com,谢谢您的支持。</div>
        </div>
        <div class="popup__footer">
          <div class="popup__left__btn" @click="handleClose">取消</div>
          <div class="popup__right__btn" @click="handleCopy">复制邮箱</div>
        </div>
      </van-popup>
    </div>
</template>

<script>
// import { EMAIL } from '@/constants';

export default {
  data() {
    return {
    };
  },
  props: {},
  components: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleClose() {
      this.$emit('input', false);
    },
    handleCopy() {
      this.$copyText('info@mal.io').then(() => {
        // 复制成功
        this.$bus.$emit('tip', { text: this.$t('personal.prompt.copySucces'), type: 'success' });
      });
    },
  },
};
</script>

<style lang='stylus' scoped>
.van-popup {
  padding: 16px 40px 24px;
  box-sizing: border-box;
  width: 364px;
  border-radius: 5px;
}

.popup__title {
  font-size: 18px;
  color: #000000;
  font-weight: 500;
  margin-bottom: 19px;
}

.popup__footer {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.popup__left__btn,
.popup__right__btn {
  flex: 0 0 134px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.popup__left__btn {
  border-radius: 4px;
  border: 1px solid #000000;
  font-size: 14px;
  color: #000;
}

.popup__right__btn {
  background: #0CC267;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
}


.popup-nft__pics {
  display: flex;
  align-items: center;

  &--item {
    flex: 0 0 64px;
    height: 64px;
    margin-right: 12px;
    background: #999;
  }
}

.popup-nft__desc {
  font-size: 14px;
  font-weight: 400;
  color: #6D7278;
  line-height: 20px;
}


</style>
